/// <reference path="../tsdeclarations/osf.d.ts" />
/// <reference path="../tsdeclarations/msajax.d.ts" />
// Utilities for providing methods that can be reused for general purpose
const URL_DELIM = "$"; // OM1422116: use macro to make this compile time replacement, no code size impact. It was "|" before bugfix

declare var otel: any;

module OfficeExt {
  export interface IBasicStorage {
    getItem(key: string): any;
    setItem(key: string, data: string): void;
    clear(): void;
    removeItem(key: string): void;
    getKeysWithPrefix(keyPrefix: string): Array<string>;
    isLocalStorageAvailable(): boolean;
  }
  /**
   * Wraps localStorage/sessionStorage methods to prevent unexpected behavior (see OM: 1472382)
   * and to simplify consumer code.
   */
  export class SafeStorage implements IBasicStorage {
    constructor(private _internalStorage: Storage) {}
    public getItem(key: string): any {
      try {
        return this._internalStorage && this._internalStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    public setItem(key: string, data: string): void {
      try {
        this._internalStorage && this._internalStorage.setItem(key, data);
      } catch (e) {
        // No action needed
      }
    }
    public clear(): void {
      try {
        this._internalStorage && this._internalStorage.clear();
      } catch (e) {
        // No action needed
      }
    }
    public removeItem(key: string): void {
      try {
        this._internalStorage && this._internalStorage.removeItem(key);
      } catch (e) {
        // No action needed
      }
    }
    public getKeysWithPrefix(keyPrefix: string): Array<string> {
      var keyList = [];
      try {
        var len = (this._internalStorage && this._internalStorage.length) || 0;
        for (var i = 0; i < len; i++) {
          var key = this._internalStorage.key(i);
          if (key.indexOf(keyPrefix) === 0) {
            keyList.push(key);
          }
        }
      } catch (e) {
        // No action needed
      }
      return keyList;
    }
    public isLocalStorageAvailable(): boolean {
      return this._internalStorage != null;
    }
  }
}
try {
  (function () {
    OSF.Flights = OSF.OUtil.parseFlights(true);
    OSF.DisabledChangeGates = OSF.OUtil.parseDisabledChangeGates(true);
  })();
} catch (ex) {}
namespace OSF {
  export enum WindowNameItemKeys {
    BaseFrameName = "baseFrameName",
    HostInfo = "hostInfo",
    XdmInfo = "xdmInfo",
    AppContext = "appContext",
    Flights = "flights",
    DisabledChangeGates = "disabledChangeGates",
    OfficeJsUrl = "officeJsUrl",
  }
  export enum XdmFieldName {
    ConversationUrl = "ConversationUrl",
    AppId = "AppId",
  }
  export enum Settings {}

  // Deprecated: The FlightNames enum is deprecated. Use the FlightTreatmentNames enum for all new flights.
  export enum FlightNames {
    AddinEnforceHttps = 2,
    AddinRibbonIdAllowUnknown = 9,
    ManifestParserDevConsoleLog = 15,
    AddinActionDefinitionHybridMode = 18,
    UseActionIdForUILessCommand = 20,
    SetFocusToTaskpaneIsEnabled = 22,
  }

  // List of flight treatments can to be added and queryalbe from the OSF.Flights dictionary.
  export enum FlightTreatmentNames {
    InsertionDialogFixesEnabled = "Microsoft.Office.SharedOnline.InsertionDialogFixesEnabled",
    EnsureStringsBeforeTrustErrorKill = "Microsoft.Office.SharedOnline.EnsureStringsBeforeTrustErrorKill", //ssnyder
    ContextSlideShowEnvironmentEnabled = "Microsoft.Office.SharedOnline.ContextSlideShowEnvironmentEnabled", // owner: qichen
    HostTrustDialog = "Microsoft.Office.SharedOnline.HostTrustDialog", //owner: junlai
    BackstageEnabled = "Microsoft.Office.SharedOnline.NewBackstageEnabled", // owner: hermanwen
    ProcessMultipleCommandsInDequeInvoker = "Microsoft.Office.SharedOnline.ProcessMultipleCommandsInDequeInvoker", // owner: rampathak
    EnablingWindowOpenUsageLogging = "Microsoft.Office.SharedOnline.EnablingWindowOpenUsageLogging", // owner: anjtp
    ExcelApiUndo25 = "Microsoft.Office.SharedOnline.ExcelApiUndo25Bump", // owner: chewalker
    ExcelApiUndo26 = "Microsoft.Office.SharedOnline.ExcelApiUndo26Bump", // owner: guliu
    ExcelApiUndo28 = "Microsoft.Office.SharedOnline.ExcelApiUndo28Bump", // owner: zhehaomi
    ExcelApiUndo29 = "Microsoft.Office.SharedOnline.ExcelApiUndo29Bump", // owner: guliu
    ExcelApiUndo30 = "Microsoft.Office.SharedOnline.ExcelApiUndo30Bump", // owner: gaokai
    ExcelApiUndo31 = "Microsoft.Office.SharedOnline.ExcelApiUndo31Bump", // owner: zhehaomi
    AgaveAuthContextApiEnabled = "Microsoft.Office.SharedOnline.AgaveAuthContextApiEnabled", // owner: dasau
    MosForWXPEnabled = "Microsoft.Office.SharedOnline.MosForWXPEnabled", // owner: mandyt
    MosOsfCacheFix = "Microsoft.Office.SharedOnline.MosOsfCacheFix", // owner: xiaoyu
    EnableMsal3SsoApi = "Microsoft.Office.SharedOnline.EnableMsal3SsoApi", // owner: kepeng
    MosRefactorEnabled = "Microsoft.Office.SharedOnline.MosRefactorEnabled", // owner: xiaoyu
    // This is intended for non-killswitch feature gate only (feature is default off)
    // For kill switch scenario - Use OSF.OUtil.isChangeGateEnabled('OfficeVSO:123456_MyFeatureName') instead
    // Please create a change gate removal tracking bug manually in VSO and reference it as part of change gate name
  }

  export let Flights = [];
  export let DisabledChangeGates = [];

  class GuidClass {
    private static HEX_CODE = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    generateNewGuid(): string {
      var result = "";
      var tick = new Date().getTime();
      var index = 0;
      // add time tick to guid
      for (; index < 32 && tick > 0; index++) {
        if (index == 8 || index == 12 || index == 16 || index == 20) {
          result += "-";
        }
        result += GuidClass.HEX_CODE[tick % 16];
        tick = Math.floor(tick / 16);
      }
      // add random number to guid
      for (; index < 32; index++) {
        if (index == 8 || index == 12 || index == 16 || index == 20) {
          result += "-";
        }
        result += GuidClass.HEX_CODE[Math.floor(Math.random() * 16)];
      }
      return result;
    }
  }

  export class OUtilClass {
    _uniqueId: number;
    _xdmInfoKey: string;
    _flightsKey: string;
    _disabledChangeGatesKey: string;
    _disabledChangeGatesKeyPrefix: string;
    _xdmSessionKeyPrefix: string;
    _flightsKeyPrefix: string;
    _fragmentSeparator: string;
    _fragmentInfoDelimiter: string;
    _classN: string;
    _loadedScripts: {
      [url: string]: { loaded: boolean; pendingCallbacks: [() => void]; timer: number | null | undefined };
    };
    _defaultScriptLoadingTimeout: number;
    _safeSessionStorage: OfficeExt.IBasicStorage;
    _safeLocalStorage: OfficeExt.IBasicStorage;
    Guid: GuidClass;
    ScriptPolicy: any;

    constructor() {
      this._uniqueId = -1;
      this._xdmInfoKey = "&_xdm_Info=";
      this._flightsKey = "&_flights=";
      this._disabledChangeGatesKey = "&_disabledChangeGates=";
      this._xdmSessionKeyPrefix = "_xdm_";
      this._flightsKeyPrefix = "_flights=";
      this._disabledChangeGatesKeyPrefix = "_disabledChangeGates=";
      this._fragmentSeparator = "#";
      this._fragmentInfoDelimiter = "&";
      this._classN = "class";
      this._loadedScripts = {};
      this._defaultScriptLoadingTimeout = 30000;
      this._safeSessionStorage = null;
      this._safeLocalStorage = null;
      this.Guid = new GuidClass();
    }

    getSessionStorage(): OfficeExt.IBasicStorage {
      if (!this._safeSessionStorage) {
        try {
          var sessionStorage = window.sessionStorage;
        } catch (ex) {
          sessionStorage = null;
        }
        this._safeSessionStorage = new OfficeExt.SafeStorage(sessionStorage);
      }
      return this._safeSessionStorage;
    }

    private _reOrderTabbableElements<T extends { tabIndex: number }>(elements: T[]): T[] {
      var bucket0: T[] = [];
      var bucketPositive: T[] = [];
      var i;
      var len = elements.length;
      var ele;
      for (i = 0; i < len; i++) {
        ele = elements[i];
        if (ele.tabIndex) {
          if (ele.tabIndex > 0) {
            bucketPositive.push(ele);
          } else if (ele.tabIndex === 0) {
            bucket0.push(ele);
          }
        } else {
          bucket0.push(ele);
        }
      }
      // In javascript, the sort method is a unstable sorting, in order to make the result stable
      // if in case their tabIndex is same, we will use the order in array to decide their position
      bucketPositive = bucketPositive.sort(function (left, right) {
        var diff = left.tabIndex - right.tabIndex;
        if (diff === 0) {
          diff = bucketPositive.indexOf(left) - bucketPositive.indexOf(right);
        }
        return diff;
      });
      return [].concat(bucketPositive, bucket0);
    }
    isChangeGateEnabled(name: string): boolean {
      // Please create a change gate removal bug manually and reference it in the change gate name
      // Convention of change gate name: OfficeVSO:123456_FeatureName
      return OSF.DisabledChangeGates.indexOf(name) === -1;
    }
    serializeSettings(settingsCollection) {
      var ret = {};
      for (var key in settingsCollection) {
        var value = settingsCollection[key];
        try {
          if (JSON) {
            //use replacer to serialize date into Date(number) format
            //where number is the number of milliseconds since 01.01.1970
            value = JSON.stringify(value, function dateReplacer(k, v) {
              return OSF.OUtil.isDate(this[k])
                ? // @ts-expect-error TS2339
                  OSF.DDA.SettingsManager.DateJSONPrefix +
                    this[k].getTime() +
                    // @ts-expect-error TS2339
                    OSF.DDA.SettingsManager.DataJSONSuffix
                : v;
            });
          } else {
            value = Sys.Serialization.JavaScriptSerializer.serialize(value);
          }
          ret[key] = value;
        } catch (ex) {
          // Ignore invalid characters and proceed
        }
      }
      return ret;
    }
    deserializeSettings(serializedSettings) {
      var ret = {};
      serializedSettings = serializedSettings || {};
      for (var key in serializedSettings) {
        var value = serializedSettings[key];
        try {
          if (JSON) {
            //use reviver to deserialize date from Date(number) format
            //where number is the number of milliseconds since 01.01.1970
            value = JSON.parse(value, function dateReviver(k, v) {
              var d;
              if (
                typeof v === "string" &&
                v &&
                v.length > 6 &&
                // @ts-expect-error TS2339
                v.slice(0, 5) === OSF.DDA.SettingsManager.DateJSONPrefix &&
                // @ts-expect-error TS2339
                v.slice(-1) === OSF.DDA.SettingsManager.DataJSONSuffix
              ) {
                d = new Date(parseInt(v.slice(5, -1)));
                if (d) {
                  return d;
                }
              }
              return v;
            });
          } else {
            //pass true as 2nd optional parameter(secure) to allow JavaScriptSerializer sanitize against JSON security using regular expression
            value = Sys.Serialization.JavaScriptSerializer.deserialize(value, true);
          }
          ret[key] = value;
        } catch (ex) {
          // Ignore invalid characters and proceed
        }
      }
      return ret;
    }
    loadScript(url, callback, timeoutInMs?) {
      if (url && callback) {
        const trustedUrl = OSF.OUtil.ScriptPolicy?.createScriptURL(url) ?? url;
        const doc = window.document;
        let _loadedScriptEntry = this._loadedScripts[url];
        if (!_loadedScriptEntry) {
          const script = doc.createElement("script");
          script.type = "text/javascript";
          _loadedScriptEntry = { loaded: false, pendingCallbacks: [callback], timer: null };
          this._loadedScripts[url] = _loadedScriptEntry;
          const onLoadCallback = function OSF_OUtil_loadScript$onLoadCallback() {
            // if timer exists, clear timer
            if (_loadedScriptEntry.timer != null) {
              clearTimeout(_loadedScriptEntry.timer);
              delete _loadedScriptEntry.timer;
            }
            _loadedScriptEntry.loaded = true;
            const pendingCallbackCount = _loadedScriptEntry.pendingCallbacks.length;
            for (let i = 0; i < pendingCallbackCount; i++) {
              const currentCallback = _loadedScriptEntry.pendingCallbacks.shift();
              currentCallback();
            }
          };
          const onLoadTimeOut = function OSF_OUtil_loadScript$onLoadTimeOut(oUtil: OUtilClass) {
            if (window.navigator.userAgent.indexOf("Trident") > 0) {
              // IE does not support the Event constructor.
              onLoadError(oUtil, null);
            } else {
              onLoadError(oUtil, new Event("Script load timed out"));
            }
          };
          const onLoadError = function OSF_OUtil_loadScript$onLoadError(oUtil: OUtilClass, errorEvent: Event) {
            delete oUtil._loadedScripts[url];
            if (_loadedScriptEntry.timer != null) {
              clearTimeout(_loadedScriptEntry.timer);
              delete _loadedScriptEntry.timer;
            }
            const pendingCallbackCount = _loadedScriptEntry.pendingCallbacks.length;
            for (let i = 0; i < pendingCallbackCount; i++) {
              const currentCallback = _loadedScriptEntry.pendingCallbacks.shift();
              currentCallback();
            }
          };
          if ((script as any).readyState) {
            //IE
            (script as any).onreadystatechange = function () {
              if ((script as any).readyState == "loaded" || (script as any).readyState == "complete") {
                (script as any).onreadystatechange = null;
                onLoadCallback();
              }
            };
          } else {
            //Other browsers
            script.onload = onLoadCallback;
          }
          script.onerror = () => {
            onLoadError(this, new Event("Script load timed out"));
          };
          // onerror doesn't work for Firefox when src is nonexisting UNC path
          // see active bug https://bugzilla.mozilla.org/show_bug.cgi?id=621276
          // use timer to work around that issue
          timeoutInMs = timeoutInMs || this._defaultScriptLoadingTimeout;
          _loadedScriptEntry.timer = setTimeout(() => {
            onLoadTimeOut(this);
          }, timeoutInMs);
          script.setAttribute("crossOrigin", "anonymous");
          script.src = trustedUrl;
          doc.head.appendChild(script);
        } else if (_loadedScriptEntry.loaded) {
          // loaded, just invoke callback directly
          callback();
        } else {
          // still loading, add callback to the pending callbacks
          _loadedScriptEntry.pendingCallbacks.push(callback);
        }
      }
    }
    loadCSS(url) {
      if (url) {
        var doc = window.document;
        var link = doc.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = url;
        doc.head.appendChild(link);
      }
    }
    parseEnum(str, enumObject) {
      var parsed = enumObject[str.trim()];
      if (typeof parsed == "undefined") {
        OsfMsAjaxFactory.msAjaxDebug.trace("invalid enumeration string:" + str);
        throw OsfMsAjaxFactory.msAjaxError.argument("str");
      }
      return parsed;
    }
    // return an unique Id (This is a simple integer. It only unique in its only window or iframe.
    getUniqueId() {
      this._uniqueId = this._uniqueId + 1;
      return this._uniqueId.toString();
    }
    formatString(...args: any[]) {
      // TODO: OSFJSREFACTOR: review function signature change.
      var source = args[0];
      return source.replace(/{(\d+)}/gm, function (match, number) {
        var index = parseInt(number, 10) + 1;
        return args[index] === undefined ? "{" + number + "}" : args[index];
      });
    }
    generateConversationId() {
      const randNums = crypto.getRandomValues(new Uint32Array([0, 0]));
      return [randNums[0].toString(16), randNums[1].toString(16), new Date().getTime().toString()].join("_");
    }
    getFrameName(cacheKey) {
      return this._xdmSessionKeyPrefix + cacheKey + this.generateConversationId();
    }
    addXdmInfoAsHash(url, xdmInfoValue) {
      // xdmInfo cannot be encoded due to compatibility with office.js and must be added to end of fragment due to this
      return OSF.OUtil.addInfoAsHash(url, this._xdmInfoKey, xdmInfoValue, false /*encodeInfo*/);
    }
    addFlightsAsHash(url, flights) {
      return OSF.OUtil.addInfoAsHash(url, this._flightsKey, flights, true /*encodeInfo*/);
    }
    addDisabledChangeGatesAsHash(url, disabledChangeGates) {
      return OSF.OUtil.addInfoAsHash(url, this._disabledChangeGatesKey, disabledChangeGates, true /*encodeInfo*/);
    }
    addInfoAsHash(url, keyName, infoValue, encodeInfo) {
      url = url.trim() || "";
      var urlParts = url.split(this._fragmentSeparator);
      var urlWithoutFragment = urlParts.shift();
      var fragment = urlParts.join(this._fragmentSeparator); //handle case where multiple # exist
      // If info can be encoded, then placement does not matter because & can be used to seperate multiple parameters
      var newFragment;
      if (encodeInfo) {
        newFragment = [keyName, encodeURIComponent(infoValue), fragment].join("");
      } else {
        // Placement matters as we cannot use any delimiter when parsing info
        newFragment = [fragment, keyName, infoValue].join("");
      }
      return [urlWithoutFragment, this._fragmentSeparator, newFragment].join("");
    }
    // Parse and return the host information from window name, return null if it doesn't exist.
    parseHostInfoFromWindowName(skipSessionStorage, windowName) {
      return OSF.OUtil.parseInfoFromWindowName(skipSessionStorage, windowName, OSF.WindowNameItemKeys.HostInfo);
    }
    // Call parseXdmInfoWithGivenFragment() with window.location.hash, the default hash string.
    // if the info from window url is null, then call parseXdmInfoFromWindowName() to get info from window name
    // OM 1882058: Don't use this function for office.js because window.location.hash may be overwritten by 3rd party JS library.
    parseXdmInfo(skipSessionStorage) {
      var xdmInfoValue = OSF.OUtil.parseXdmInfoWithGivenFragment(skipSessionStorage, window.location.hash);
      if (!xdmInfoValue) {
        xdmInfoValue = OSF.OUtil.parseXdmInfoFromWindowName(skipSessionStorage, window.name);
      }
      return xdmInfoValue;
    }

    parseXdmInfoFromWindowName(skipSessionStorage, windowName) {
      return OSF.OUtil.parseInfoFromWindowName(skipSessionStorage, windowName, OSF.WindowNameItemKeys.XdmInfo);
    }
    parseXdmInfoWithGivenFragment(skipSessionStorage, fragment) {
      return OSF.OUtil.parseInfoWithGivenFragment(
        this._xdmInfoKey,
        this._xdmSessionKeyPrefix,
        false /*decodeInfo*/,
        skipSessionStorage,
        fragment,
      );
    }
    parseFlights(skipSessionStorage) {
      var flights = OSF.OUtil.parseFlightsWithGivenFragment(skipSessionStorage, window.location.hash);
      if (flights.length == 0) {
        flights = OSF.OUtil.parseFlightsFromWindowName(skipSessionStorage, window.name);
      }
      return flights;
    }
    parseDisabledChangeGates(skipSessionStorage) {
      var disabledChangeGates = OSF.OUtil.parseDisabledChangeGatesWithGivenFragment(
        skipSessionStorage,
        window.location.hash,
      );
      if (disabledChangeGates.length == 0) {
        disabledChangeGates = OSF.OUtil.parseDisabledChangeGatesFromWindowName(skipSessionStorage, window.name);
      }
      return disabledChangeGates;
    }
    checkFlight(flight) {
      return OSF.Flights && OSF.Flights.indexOf(flight) >= 0;
    }
    pushFlight(flight) {
      if (OSF.Flights.indexOf(flight) < 0) {
        OSF.Flights.push(flight);
        return true;
      }
      return false;
    }
    getBooleanSetting(settingName) {
      return OSF.OUtil.getBooleanFromDictionary(OSF.Settings, settingName);
    }
    getBooleanFromDictionary(settings: any, settingName: string) {
      var result: boolean =
        settings &&
        settingName &&
        settings[settingName] !== undefined &&
        settings[settingName] &&
        ((typeof settings[settingName] === "string" && settings[settingName].toUpperCase() === "TRUE") ||
          (typeof settings[settingName] === "boolean" && settings[settingName]));
      return result !== undefined ? result : false;
    }
    parseFlightsFromWindowName(skipSessionStorage, windowName) {
      return OSF.OUtil.parseArrayWithDefault(
        OSF.OUtil.parseInfoFromWindowName(skipSessionStorage, windowName, OSF.WindowNameItemKeys.Flights),
      );
    }
    parseFlightsWithGivenFragment(skipSessionStorage, fragment) {
      return OSF.OUtil.parseArrayWithDefault(
        OSF.OUtil.parseInfoWithGivenFragment(
          this._flightsKey,
          this._flightsKeyPrefix,
          true /*decodeInfo*/,
          skipSessionStorage,
          fragment,
        ),
      );
    }
    parseDisabledChangeGatesFromWindowName(skipSessionStorage, windowName) {
      return OSF.OUtil.parseArrayWithDefault(
        OSF.OUtil.parseInfoFromWindowName(skipSessionStorage, windowName, OSF.WindowNameItemKeys.DisabledChangeGates),
      );
    }
    parseDisabledChangeGatesWithGivenFragment(skipSessionStorage, fragment) {
      return OSF.OUtil.parseArrayWithDefault(
        OSF.OUtil.parseInfoWithGivenFragment(
          this._disabledChangeGatesKey,
          this._disabledChangeGatesKeyPrefix,
          true /*decodeInfo*/,
          skipSessionStorage,
          fragment,
        ),
      );
    }
    parseArrayWithDefault(jsonString) {
      var array = [];
      try {
        array = JSON.parse(jsonString);
      } catch (ex) {}
      if (!Array.isArray(array)) {
        array = [];
      }
      return array;
    }
    parseInfoFromWindowName(skipSessionStorage, windowName, infoKey) {
      try {
        var windowNameObj = JSON.parse(windowName);
        var infoValue = windowNameObj != null ? windowNameObj[infoKey] : null;
        var osfSessionStorage = this.getSessionStorage();
        if (!skipSessionStorage && osfSessionStorage && windowNameObj != null) {
          var sessionKey = windowNameObj[OSF.WindowNameItemKeys.BaseFrameName] + infoKey;
          if (infoValue) {
            osfSessionStorage.setItem(sessionKey, infoValue);
          } else {
            //try reading from session if not available from windowName
            infoValue = osfSessionStorage.getItem(sessionKey);
          }
        }
        return infoValue;
      } catch (Exception) {
        return null;
      }
    }
    parseInfoWithGivenFragment(infoKey, infoKeyPrefix, decodeInfo, skipSessionStorage, fragment) {
      var fragmentParts = fragment.split(infoKey);
      var infoValue = fragmentParts.length > 1 ? fragmentParts[fragmentParts.length - 1] : null;
      if (decodeInfo && infoValue != null) {
        if (infoValue.indexOf(this._fragmentInfoDelimiter) >= 0) {
          infoValue = infoValue.split(this._fragmentInfoDelimiter)[0];
        }
        infoValue = decodeURIComponent(infoValue);
      }
      var osfSessionStorage = this.getSessionStorage();
      if (!skipSessionStorage && osfSessionStorage) {
        var sessionKeyStart = window.name.indexOf(infoKeyPrefix);
        if (sessionKeyStart > -1) {
          var sessionKeyEnd = window.name.indexOf(";", sessionKeyStart);
          if (sessionKeyEnd == -1) {
            sessionKeyEnd = window.name.length;
          }
          var sessionKey = window.name.substring(sessionKeyStart, sessionKeyEnd);
          if (infoValue) {
            osfSessionStorage.setItem(sessionKey, infoValue);
          } else {
            //try reading from session if not available from hash
            infoValue = osfSessionStorage.getItem(sessionKey);
          }
        }
      }
      return infoValue;
    }
    // get xdm conversation id from search string
    getConversationId() {
      var searchString = window.location.search;
      var conversationId = null;
      if (searchString) {
        var index = searchString.indexOf("&");
        // search string always start with ?, so get content at index 1
        conversationId = index > 0 ? searchString.substring(1, index) : searchString.substr(1);
        if (conversationId && conversationId.charAt(conversationId.length - 1) === "=") {
          conversationId = conversationId.substring(0, conversationId.length - 1);
          if (conversationId) {
            conversationId = decodeURIComponent(conversationId);
          }
        }
      }
      return conversationId;
    }
    // split a xdminfo or hostvalue info, if doesn't contain new delimiter, using "|" and try to split again
    getInfoItems(strInfo) {
      var items = strInfo.split(URL_DELIM); //Try new delimiter first
      if (typeof items[1] == "undefined") {
        //check if it contains the new delimiter.
        items = strInfo.split("|"); //fallback to old delimiter
      }
      if (typeof items[1] == "undefined") {
        //check if it contains the pipe delimiter
        items = strInfo.split("%7C"); //safari replaces | with %7C on a server redirect
      }
      return items;
    }
    // get xdm field value from xdm info, skipSessionStorage: whether we need to get the xdm info from session storage if it is null in the window url string
    getXdmFieldValue(xdmFieldName, skipSessionStorage) {
      var fieldValue = "";
      var xdmInfoValue = OSF.OUtil.parseXdmInfo(skipSessionStorage);
      if (xdmInfoValue) {
        var items = OSF.OUtil.getInfoItems(xdmInfoValue);
        if (items != undefined && items.length >= 3) {
          switch (xdmFieldName) {
            case OSF.XdmFieldName.ConversationUrl:
              fieldValue = items[2];
              break;
            case OSF.XdmFieldName.AppId:
              fieldValue = items[1];
              break;
          }
        }
      }
      return fieldValue;
    }
    validateParamObject(params, expectedProperties, callback) {
      var e = Function._validateParams(arguments, [
        { name: "params", type: Object, mayBeNull: false },
        { name: "expectedProperties", type: Object, mayBeNull: false },
        { name: "callback", type: Function, mayBeNull: true },
      ]);
      if (e) throw e;
      for (var p in expectedProperties) {
        e = Function._validateParameter(params[p], expectedProperties[p], p);
        if (e) throw e;
      }
    }
    finalizeProperties(obj, descriptor) {
      descriptor = descriptor || {};
      var props = Object.getOwnPropertyNames(obj);
      var propsLength = props.length;
      for (var i = 0; i < propsLength; i++) {
        var prop = props[i];
        var desc = Object.getOwnPropertyDescriptor(obj, prop);
        if (!desc.get && !desc.set) {
          desc.writable = descriptor.writable || false;
        }
        desc.configurable = descriptor.configurable || false;
        desc.enumerable = descriptor.enumerable || true;
        Object.defineProperty(obj, prop, desc);
      }
      return obj;
    }
    isDate(obj) {
      return Object.prototype.toString.apply(obj) === "[object Date]";
    }
    xhrGet(url, onSuccess, onError) {
      var xmlhttp;
      try {
        xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
          if (xmlhttp.readyState == 4) {
            if (xmlhttp.status == 200) {
              onSuccess(xmlhttp.responseText);
            } else {
              onError(xmlhttp.status);
            }
          }
        };
        xmlhttp.open("GET", url, true);
        xmlhttp.send();
      } catch (ex) {
        onError(ex);
      }
    }
    // UTF-16 string encoding to base64 string
    // This method encodes the utf16 byte representation for the input string using base64
    encodeBase64Utf16(input: string) {
      if (!input) return input;
      const stringCodeU16 = new Uint16Array(input.length).map((_, i) => input.charCodeAt(i));
      const stringCodeU8 = new Uint8Array(stringCodeU16.buffer);
      const encodedString = String.fromCharCode.apply(null, stringCodeU8);
      return btoa(encodedString);
    }
    getLocalStorage() {
      if (!this._safeLocalStorage) {
        try {
          var localStorage = window.localStorage;
        } catch (ex) {
          localStorage = null;
        }
        this._safeLocalStorage = new OfficeExt.SafeStorage(localStorage);
      }
      return this._safeLocalStorage;
    }
    convertIntToCssHexColor(val) {
      var hex = "#" + (Number(val) + 0x1000000).toString(16).slice(-6);
      return hex;
    }
    attachClickHandler(element, handler) {
      element.onclick = function (e) {
        handler();
      };
      element.ontouchend = function (e) {
        handler();
        e.preventDefault();
      };
    }
    getQueryStringParamValue(queryString, paramName) {
      var e = Function._validateParams(arguments, [
        { name: "queryString", type: String, mayBeNull: false },
        { name: "paramName", type: String, mayBeNull: false },
      ]);
      if (e) {
        OsfMsAjaxFactory.msAjaxDebug.trace("OSF_Outil_getQueryStringParamValue: Parameters cannot be null.");
        return "";
      }
      var queryExp = new RegExp("[\\?&]" + paramName + "=([^&#]*)", "i");
      if (!queryExp.test(queryString)) {
        OsfMsAjaxFactory.msAjaxDebug.trace("OSF_Outil_getQueryStringParamValue: The parameter is not found.");
        return "";
      }
      return queryExp.exec(queryString)[1];
    }
    /**
     * Get part of the hostname allowed for logging
     * Ex: Url: https://a.b.c.d.e/some/path  ---parseUrl(Url).hostname--> a.b.c.d.e --> Only d.e is allowed for logging
     */
    getHostnamePortionForLogging(hostname) {
      var e = Function._validateParams(arguments, [{ name: "hostname", type: String, mayBeNull: false }]);
      if (e) {
        return "";
      }
      var hostnameSubstrings = hostname.split(".");
      var len = hostnameSubstrings.length;
      if (len >= 2) {
        return hostnameSubstrings[len - 2] + "." + hostnameSubstrings[len - 1];
      } else if (len == 1) {
        return hostnameSubstrings[0];
      }
    }
    isiOS() {
      return window.navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false;
    }
    doesUrlHaveSupportedProtocol(url: string): boolean {
      var isValid = false;
      if (url) {
        try {
          var parsedUrl = OSF.OUtil.parseUrl(url, /*enforceHttps*/ false);
          isValid = parsedUrl.protocol === "https:" || parsedUrl.protocol === "http:";
        } catch (ex) {
          this.sendTelemetryEvent("Office.Extensibility.UrlParsingForProtocolCheck", [
            {
              name: "errorMessage",
              string: "Fix for bug 7142881 exception hit in officeutils.ts function doesUrlHaveSupportedProtocol.",
            },
            { name: "tag", string: "0x1e88019a" /* tag_48ag0 */ },
          ]);
          var decodedUrl = decodeURIComponent(url);
          var matches = decodedUrl.match(/^https?:\/\/.+$/gi);
          isValid = matches != null;
        }
      }
      return isValid;
    }
    containsPort(url, protocol, hostname, portNumber) {
      return (
        url.startsWith(protocol + "//" + hostname + ":" + portNumber) || url.startsWith(hostname + ":" + portNumber)
      );
    }
    getRedundandPortString(url, parser) {
      if (!url || !parser) return "";
      if (parser.protocol == "https:" && this.containsPort(url, "https:", parser.hostname, "443")) return ":443";
      else if (parser.protocol == "http:" && this.containsPort(url, "http:", parser.hostname, "80")) return ":80";
      return "";
    }
    removeChar(url, indexOfCharToRemove) {
      if (indexOfCharToRemove < url.length - 1)
        return url.substring(0, indexOfCharToRemove) + url.substring(indexOfCharToRemove + 1);
      else if (indexOfCharToRemove == url.length - 1) return url.substring(0, url.length - 1);
      else return url;
    }
    cleanUrlOfChar(url, charToClean) {
      let i;
      for (i = 0; i < url.length; i++) {
        if (url.charAt(i) === charToClean) {
          if (i + 1 >= url.length) {
            return this.removeChar(url, i);
          } else if (charToClean === "/") {
            if (url.charAt(i + 1) === "?" || url.charAt(i + 1) === "#") {
              return this.removeChar(url, i);
            }
          } else if (charToClean === "?") {
            if (url.charAt(i + 1) === "#") {
              return this.removeChar(url, i);
            }
          }
        }
      }
      return url;
    }
    cleanUrl(url) {
      url = this.cleanUrlOfChar(url, "/");
      url = this.cleanUrlOfChar(url, "?");
      url = this.cleanUrlOfChar(url, "#");
      //remove redundand ports
      if (url.substr(0, 8) == "https://") {
        let portIndex = url.indexOf(":443");
        if (portIndex != -1) {
          if (
            portIndex == url.length - 4 ||
            url.charAt(portIndex + 4) == "/" ||
            url.charAt(portIndex + 4) == "?" ||
            url.charAt(portIndex + 4) == "#"
          ) {
            url = url.substring(0, portIndex) + url.substring(portIndex + 4);
          }
        }
        // eslint-disable-next-line @microsoft/sdl/no-insecure-url
      } else if (url.substr(0, 7) == "http://") {
        let portIndex = url.indexOf(":80");
        if (portIndex != -1) {
          if (
            portIndex == url.length - 3 ||
            url.charAt(portIndex + 3) == "/" ||
            url.charAt(portIndex + 3) == "?" ||
            url.charAt(portIndex + 3) == "#"
          ) {
            url = url.substring(0, portIndex) + url.substring(portIndex + 3);
          }
        }
      }
      return url;
    }
    // Check if the url actually contains the port in the string. It should be at the end of urlObj.host.
    isPortPartOfUrl(urlObj: URL): boolean {
      return urlObj.host.lastIndexOf(":" + urlObj.port) == urlObj.host.length - urlObj.port.length - 1;
    }
    /**
     * Parse url into an object similar to the new URL library (enforceHttps decideds if SSL is enforced).
     * Caveat: as per the new URL library, redundant port numbers in the url such as ':443' when using 'https:' will be ignored/not returned
     */
    parseUrl(url: string, enforceHttps = false): any {
      if (!url) {
        return undefined;
      }
      const notHttpsErrorMessage = "NotHttps";
      try {
        const urlObj = new URL(url);
        if (urlObj && urlObj.protocol && urlObj.host && urlObj.hostname) {
          if (OSF.OUtil.checkFlight(OSF.FlightNames.AddinEnforceHttps)) {
            if (enforceHttps && urlObj.protocol != "https:") throw new Error(notHttpsErrorMessage);
          }
          return urlObj;
        }
      } catch (err) {
        if (err.message === notHttpsErrorMessage) throw err;
      }
      return {};
    }
    focusToFirstTabbable(all, backward) {
      var next;
      var focused = false;
      var candidate;
      var setFlag = function (e) {
        focused = true;
      };
      var findNextPos = function (allLen, currPos, backward) {
        if (currPos < 0 || currPos > allLen) {
          return -1;
        } else if (currPos === 0 && backward) {
          return -1;
        } else if (currPos === allLen - 1 && !backward) {
          return -1;
        }
        if (backward) {
          return currPos - 1;
        } else {
          return currPos + 1;
        }
      };
      all = this._reOrderTabbableElements(all);
      next = backward ? all.length - 1 : 0;
      if (all.length === 0) {
        return null;
      }
      while (!focused && next >= 0 && next < all.length) {
        candidate = all[next];
        // Force a focus move to window in order to fix weird behavior on latest chrome (50.0.2661.102)
        // that it refuse to set focus on an element it think was focused (actually the focus already moved away)
        window.focus();
        candidate.addEventListener("focus", setFlag);
        candidate.focus();
        candidate.removeEventListener("focus", setFlag);
        next = findNextPos(all.length, next, backward);
        // Treat for browsers who's setFlag callback won't be trigger immediately
        if (!focused && candidate === document.activeElement) {
          focused = true;
        }
      }
      if (focused) {
        return candidate;
      } else {
        return null;
      }
    }
    focusToNextTabbable(all, curr, shift) {
      var currPos;
      var next;
      var focused = false;
      var candidate;
      var setFlag = function (e) {
        focused = true;
      };
      var findCurrPos = function (all, curr) {
        var i = 0;
        for (; i < all.length; i++) {
          if (all[i] === curr) {
            return i;
          }
        }
        return -1;
      };
      var findNextPos = function (allLen, currPos, shift) {
        if (currPos < 0 || currPos > allLen) {
          return -1;
        } else if (currPos === 0 && shift) {
          return -1;
        } else if (currPos === allLen - 1 && !shift) {
          return -1;
        }
        if (shift) {
          return currPos - 1;
        } else {
          return currPos + 1;
        }
      };
      all = this._reOrderTabbableElements(all);
      currPos = findCurrPos(all, curr);
      next = findNextPos(all.length, currPos, shift);
      if (next < 0) {
        return null;
      }
      while (!focused && next >= 0 && next < all.length) {
        candidate = all[next];
        candidate.addEventListener("focus", setFlag);
        candidate.focus();
        candidate.removeEventListener("focus", setFlag);
        next = findNextPos(all.length, next, shift);
        // Treat for browsers who's setFlag callback won't be trigger immediately
        if (!focused && candidate === document.activeElement) {
          focused = true;
        }
      }
      if (focused) {
        return candidate;
      } else {
        return null;
      }
    }
    hashCode(str: string) {
      let hash = 0;
      if (str != null) {
        let i = 0;
        const len = str.length;
        while (i < len) {
          hash = ((hash << 5) - hash + str.charCodeAt(i++)) | 0;
        }
      }
      return hash;
    }
    getBOMCodepointLength(data: string): number {
      // Javascript supports only three types of escaping sequence
      // Hexadecimal escape sequence, Unicode escape sequence and Code point escape sequence
      // For Code Point escape sequence the value of BOM is same as FFEF
      // utf-16 escaped \uFFEF
      if (data.charCodeAt(0) === 0xfeff) {
        return 1;
      }
      // utf-8 escaped \xEF\xBB\xBF
      else if (
        data.length >= 3 &&
        data.charCodeAt(0) === 0xef &&
        data.charCodeAt(1) === 0xbb &&
        data.charCodeAt(2) === 0xbf
      ) {
        return 3;
      }

      return 0;
    }
    sendTelemetryEvent(eventName: string, dataFieldsValue: any): boolean {
      if (typeof otel !== "undefined" && typeof otel.sendTelemetryEvent !== "undefined") {
        otel.sendTelemetryEvent({
          name: eventName,
          dataFields: dataFieldsValue,
        });
        return true;
      }
      return false;
    }
    sendActivityEvent(eventName: string, eventDuration: any, eventSucceeded: any, dataFieldsValue: any): boolean {
      if (typeof otel !== "undefined" && typeof otel.sendActivityEvent !== "undefined") {
        otel.sendActivityEvent({
          name: eventName,
          durationMs: eventDuration,
          succeeded: eventSucceeded,
          dataFields: dataFieldsValue,
        });
        return true;
      }
      return false;
    }

    // return if MetaOS for WXP is enabled
    // may add more fallback conditions in the future
    isMosForWXPEnabled(): boolean {
      return (
        this.getBooleanSetting("MosForWXPEnabled") || // Setting value passed from 1JS to avoid N/N-1 issue every time we have change on FG control
        (OSF.OUtil.checkFlight(OSF.FlightTreatmentNames.MosForWXPEnabled) && !this.getBooleanSetting("IsAnonymousUser")) // Todo:keep MosForWXPEnabled only after the change full deployed
      );
    }
  }
  export let OUtil = new OUtilClass();
}
